export default __webpack_public_path__ + "static/media/internal_error.8bc1a978.png";